const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Pet Sawyer: el regalo del Pack 2 solo puede ir con 2 o más orejeras */
(function () {
  if (window.__psGuard || !window.fetch) return;
  window.__psGuard = true;
  var SIZE_IDS = [58279181615486, 58279181648254, 58279181681022];
  var GIFT_ID = 58279187677566;
  var origFetch = window.fetch.bind(window);
  var fixing = false;
  function readCart() {
    return origFetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0, g = null;
      c.items.forEach(function (it) { if (SIZE_IDS.indexOf(it.variant_id) > -1) n += it.quantity; if (it.variant_id === GIFT_ID) g = it; });
      return { n: n, g: g };
    });
  }
  function fix(reload) {
    if (fixing) return Promise.resolve(false);
    return readCart().then(function (s) {
      if (s.g && s.n < 2) {
        fixing = true;
        return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: s.g.key, quantity: 0 }) })
          .then(function () { fixing = false; if (reload) window.location.reload(); return true; });
      }
      return false;
    }).catch(function () { fixing = false; return false; });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (!fixing && /\/cart\/(change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(function () { fix(true); }, 60); }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout, .cart__checkout-button, a[href*="/checkout"]');
    if (!b || b.__psOk) return;
    e.preventDefault(); e.stopImmediatePropagation();
    fix(false).then(function (changed) {
      if (changed) { window.location.reload(); return; }
      b.__psOk = true; b.click(); setTimeout(function () { b.__psOk = false; }, 3000);
    });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.__psOk || (f.getAttribute('action') || '').indexOf('/cart') === -1) return;
    var sub = e.submitter;
    if (!sub || sub.getAttribute('name') !== 'checkout') return;
    e.preventDefault(); e.stopImmediatePropagation();
    fix(false).then(function (changed) {
      if (changed) { window.location.reload(); return; }
      f.__psOk = true;
      if (f.requestSubmit) f.requestSubmit(sub); else { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit(); }
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(true); }); else fix(true);
})();
